/*
 * @Descripttion: 
 * @Author: voanit
 * @Date: 2021-09-07 11:13:27
 * @LastEditors: voanit
 * @LastEditTime: 2021-09-08 13:38:15
 */
import { request } from './request'

export const getMailAuthUrl = () => {
  const url = '/api/v1/mailchimp/authorize/link'
  return request({
    method: 'GET',
    url: url,
  })
}

export const getMailchimpDetail = () => {
  const url = '/api/v1/mailchimp'
  return request({
    method: 'GET',
    url: url,
  })
}

export const cancelMailAuth = () => {
  const url = '/api/v1/mailchimp/authorize/stop'
  return request({
    method: 'GET',
    url: url,
  })
}
//团队-查询团队成员列表
export const teamStaff = (params) => {
  const url = '/api/v1/user/ocean/team/users/list'
  return request({
    method: 'GET',
    url: url,
    params
  })
}
//团队添加或更新
export const teamUpdate = (data) => {
  const url = '/api/v1/user/ocean/team/saveOrUpdate'
  return request({
    method: 'POST',
    url: url,
    data
  })
}
//团队列表接口 
export const teamList = (data) => {
  const url = '/api/v1/user/ocean/team/page'
  return request({
    method: 'POST',
    url: url,
    data
  })
}
//团队删除接口

export const teamItemDel = (data) => {
  const url = `/api/v1/user/ocean/team/delete/${data}`
  return request({
    method: 'Delete',
    url: url,
    data
  })
}
// 团队-删除员工
export const teamStaffDel = (data) => {
  const url = `/api/v1/user/ocean/team/authorized/${data.teamId}/${data.userId}`
  return request({
    method: 'Delete',
    url: url,
    data
  })
}
//团队-添加员工 
export const teamStaffAdd = (data) => {
  const url = '/api/v1/user/ocean/team/users/add'
  return request({
    method: 'POST',
    url: url,
    data
  })
}
//团队-添加员工 
export const teamStaffEdit = (data) => {
  const url = '/api/v1/user/ocean/team/users/update'
  return request({
    method: 'POST',
    url: url,
    data
  })
}
//团队-查询已选数据权限列表
export const teamAuthList = (data) => {
  const url = `/api/v1/user/ocean/team/data/authorized/${data}/detail?data_type=1`
  return request({
    method: 'GET',
    url: url,
    data
  })
}
//团队-新增编辑数据权限
export const teamAuthUpdate = (data) => {
  const url = '/api/v1/user/ocean/team/data/authorized'
  return request({
    method: 'POST',
    url: url,
    data
  })
}
